import { BaseColumnModel } from '~components/dynamic-table/models/column-types/base-column.model';
import { BaseSearchStore } from '~core/abstractions/base-search.store';
import { Identifyable } from '~core/abstractions/identifyable';

export class DataSelectionDialogDataModel<T extends Identifyable<TId>, TId> {
    dialogTitleKey!: string;
    store!: BaseSearchStore<T, TId>;
    columnConfig!: BaseColumnModel[];
    isMultiSelect? = false;
    shouldDisplaySelectAllButton? = true;

    constructor(init: DataSelectionDialogDataModel<T, TId>) {
        Object.assign(this, init);
        this.isMultiSelect = init.isMultiSelect ?? false;
        this.shouldDisplaySelectAllButton = init.shouldDisplaySelectAllButton ?? true;
    }
}
